import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hsrdfaezh: FaireProductEntity = {
  token: "p_4hsrdfaezh",
  type: "product",
  name: "You Got This Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e889c1c7497f78404613eb6dd2b3ad3d20a1e66f1edd6d545da0d9f79937e7bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f7ad1605e2579aebd0776b2da6ce1b62720f44816ad0085628bb5fbf49a22a8.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:00.928Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
